import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'fb-product-composition',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './product-composition.component.html',
  styleUrls: ['./product-composition.component.scss']
})
export class ProductCompositionComponent {

	@Input()
	public weight: string = '';

	@Input()
	public gsm: number | undefined =  undefined;
}
